import AccessResponse from "admin/types/interfaces/access";
import { useFetcher } from "~/hooks/useFetcher";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

const useGroupAccess = (groupName: string) => {
  return useFetcher<AccessResponse>(`${ACCESS_CONTROLLER_V1}/user-tags/${groupName}/access`);
};

export default useGroupAccess;
